// extracted by mini-css-extract-plugin
export default {"emptyReports":"ReportsTable-emptyReports-1fe6a6e45f57b4e462b3031b0b9f4e66"};